var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.28,
    height: 36.467,
    viewBox: "0 0 36.28 36.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#464646}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(-140.974 -237.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M172.354 258.583c3.816-12.814-8.856-25.175-21.547-19.917-12 4.974-13.322 21.927-2.278 28.737a16.389 16.389 0 0 0 19.907-2.4h-1.556l8.5 8.56a1.1 1.1 0 0 0 1.556-1.556l-8.5-8.56a1.119 1.119 0 0 0-1.556 0 13.965 13.965 0 1 1 3.352-5.447 1.1 1.1 0 0 0 2.122.585z",
    className: "cls-1",
    "data-name": "Path 8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.4419ba1b.svg";
export { ForwardRef as ReactComponent };